import { MessageCircle } from "lucide-react";
import { WHATSAPP_NUMBER, whatsappMessage } from "@/config";
import { track, attribution } from "@/lib/track";
import { useLocale } from "@/i18n/LocaleContext";

// ONE global viewport-fixed WhatsApp / Talk to a Specialist control.
// No scroll/section/observe logic — visual state is pure CSS:
// desktop (lg+) ALWAYS expanded text + icon, hero to footer;
// below lg the label drops to icon-only for small-screen usability.
// Number verified: +351 910 619 033. Message configurable per page/locale.
export const WhatsAppFloat = ({ page = "open-your-gym" }) => {
  const { lang, t } = useLocale();
  const onClick = () => {
    track("whatsapp_click", { page, ...attribution() });
    window.open(
      `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(whatsappMessage({ page, lang }))}`,
      "_blank",
      "noopener"
    );
  };

  return (
    <button
      type="button"
      onClick={onClick}
      aria-label="WhatsApp — Talk to a Specialist"
      style={{
        bottom: "max(1.25rem, env(safe-area-inset-bottom))",
        insetInlineEnd: "max(1.25rem, env(safe-area-inset-right))",
      }}
      className="group fixed z-[60] flex items-center gap-3 border border-carbon-600 bg-carbon-900/95 p-3 backdrop-blur-md transition-colors duration-300 hover:border-signal lg:py-3 lg:pl-3.5 lg:pr-4"
      data-testid="whatsapp-float-btn"
    >
      <span className="relative flex h-9 w-9 items-center justify-center bg-signal">
        <MessageCircle className="h-[18px] w-[18px] text-white" />
        <span className="absolute -right-0.5 -top-0.5 h-2 w-2 animate-pulse bg-white/90" />
      </span>
      <span className="hidden text-left lg:block rtl:text-right">
        <span className="block font-mono text-[10px] font-medium uppercase tracking-[0.2em] text-white">
          {t("wa.title", "WhatsApp")}
        </span>
        <span className="block font-mono text-[9px] uppercase tracking-[0.15em] text-titanium/50 transition-colors group-hover:text-titanium">
          {t("wa.subtitle", "Talk to a Specialist")}
        </span>
      </span>
    </button>
  );
};
